/* ============================================================
   COUNTER ANIMATO — GIARDINO D'AUTORE
   Rileva automaticamente i numeri nei titoli della sezione Chi siamo
   ============================================================ */

(function () {
  // Trova tutti i titoli H3/H2 nella pagina che iniziano con un numero
  const candidates = document.querySelectorAll('.rich-text__heading, .multicolumn-card h3, h3');
  const counters = [];

  candidates.forEach((el) => {
    const text = el.textContent.trim();
    // Regex: cattura numeri tipo "20+", "12.000", "1.500+", "500+", "5"
    const match = text.match(/^([\d.]+)(\+?)\s+(.+)$/);
    if (!match) return;

    const numberStr = match[1].replace(/\./g, '');
    const target = parseInt(numberStr, 10);
    if (isNaN(target) || target < 2) return;

    const suffix = match[2];
    const rest = match[3];

    // Sostituisci con uno span animabile
    el.innerHTML = '<span class="count-up-num">0' + suffix + '</span> ' + rest;
    const span = el.querySelector('.count-up-num');
    span.dataset.target = target;
    span.dataset.suffix = suffix;
    counters.push(span);
  });

  if (!counters.length) return;

  function animateCount(el) {
    if (el.dataset.animated === 'true') return;
    el.dataset.animated = 'true';

    const target = parseInt(el.dataset.target, 10);
    const suffix = el.dataset.suffix || '';
    const duration = 2500;
    const startTime = performance.now();

    function easeOutQuart(t) {
      return 1 - Math.pow(1 - t, 4);
    }

    function formatNumber(num) {
      return num.toLocaleString('it-IT');
    }

    function tick(now) {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = easeOutQuart(progress);
      const current = Math.floor(eased * target);

      el.textContent = formatNumber(current) + suffix;

      if (progress < 1) {
        requestAnimationFrame(tick);
      } else {
        el.textContent = formatNumber(target) + suffix;
      }
    }

    requestAnimationFrame(tick);
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        animateCount(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.3 });

  counters.forEach((el) => observer.observe(el));
})();